



























































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Unit extends Vue {
    private loading = false;
    private unitTree: any[] = [];
    private defaultProps = {
        children: 'children',
        label: 'name'
    }
    private curUnitId = 0;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];

    private editFormVisible = false;
    private editForm: any = {};

    created() {
        this.reloadTree(true);
    }

    // 加载机构树
    reloadTree(isReload: boolean) {
        this.$apis.getMyUnitTree()
            .then((res: any) => {
                this.unitTree = res.data;
                
                this.pageIndex = 1;
                if (isReload === true) {
                    this.curUnitId = this.unitTree[0].id;
                    this.reload();
                }
            });
    }

    // 加载下级机构列表
    reload() {
        this.$apis.getUnitsByParent(this.curUnitId, this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.pagedData = res.data;
                this.total = res.total;
            });
    }

    // 选中机构-加载下级机构列表
    onChildUnit(data: any) {
        this.curUnitId = data.id;
        this.pageIndex = 1;
        this.reload();
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的单位, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            
            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.delUnits({ data: { ids: ids } })
                .then((res: any) => {
                    this.reloadTree(false); // 刷新机构树
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 新增
    onAdd() {
        this.editForm = {
            parentId: this.curUnitId,
            name: "",
            sequence: 0,
        }
        this.editFormVisible = true;
    }

    // 编辑
    onEdit(row: any) {
        this.editForm = {
            id: row.id,
            parentId: row.parentId,
            name: row.name,
            sequence: row.sequence,
        }
        this.editFormVisible = true;
    }

    // 提交
    onFinish() {
        this.editFormVisible = false;
        
        if (typeof (this.editForm.id) == "undefined") {
            // 新增
            this.$apis.postUnit(this.editForm)
                .then((res: any) => {
                    this.reloadTree(false); // 刷新机构树
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '提交成功!'
                    });
                });
        } else {
            // 编辑
            this.$apis.putUnit(this.editForm)
                .then((res: any) => {
                    this.reloadTree(false); // 刷新机构树
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                });
        }
    }
}
